import { ExprEditMode } from "./ExpressEntity";
import { AllOperator, NumberOperator, StringOperator } from "./ComputeResource";

//简易表达式--实体
/**
 * 简易表达式：计算条件实体
 */
export class ConditionRule {
  //字段
  computeField: string;

  //值
  value: string;

  //操作符
  operator: string;

  //左括号
  lbracket: string;

  //右括号
  rbracket: string;

  //关系操作符
  relation: string;
}

/**
 * 简易表达式：计算条件视图类
 */
export class ConditionRuleView extends ConditionRule {
  //字段名称
  fieldName: string;

  //绑定组织的信息
  sysorgData: { showText: string, bindingData: any } = null;
}

/**
 * 简易表达式--树节点信息实体
 */
export class ComputeTreeNode {
  //id
  id: number;

  //父节点id
  parentId: number;

  //编号
  code: string;

  //名称
  name: string;

  //链式编号
  chainCode: string;

  //链式名称
  chainName: string;

  //树信息
  treeInfo: ComputeTreeInfo = new ComputeTreeInfo;

  //字段类型
  type: string;

  //修复已保存数据打开报错问题
  data: any
}
/**
 * 简易表达式--树节点父节点实体
 */
class ComputeTreeInfo {
  //层数
  layer: number;

  //路径
  path: string;
}

/**
 * 表达式返回结果
 * @property type 表达式类型（简易/高级）
 * @property text 表达式文本
 * @date 2021-01-11
 * @author Vincent
 */
export class ExpressionResult {

  public type: ExprEditMode;

  public text: string;
}

/**
 * 简易表达式--工具类
 */
export class ComputeExpressUtils {

  /**
 * 简易表达式--返回路径信息
 * @param path 路径信息
 * @returns 路径信息
 */
  public static getPath(path: number): string {
    let num = "";
    if (path < 10) {
      num = "000" + path;
    } else if (10 <= path && path < 100) {
      num = "00" + path;
    } else if (100 <= path && path < 1000) {
      num = "0" + path;
    } else {
      num = path + "";
    }
    return num;
  }

  /**
   * 根据字段类型获取操作符
   * @param type 字段类型
   * @returns 对应操作符集合
   */
  public static getOperator(type: string) {
    if (type == "String" || type == "Date" || type == "DateTime")
      return StringOperator;
    else if (type == "Decimal" || type == "Integer" || type == "Byte" || type == "Binary")
      return NumberOperator;
    else
      return AllOperator;
  }

  /**
   * 转化为表达式串
   * @param conditions 简易表达式-计算条件列表
   * @returns 
   */
  public static convertExpr(conditions: ConditionRule[]): string {
    let expr = "";
    if (conditions) {
      let count = 0;
      let length = conditions.length;
      conditions.forEach(item => {
        count++;
        if (count < length) {
          if (item.operator == "==" || item.operator == "!=" || item.operator == ">" ||
            item.operator == ">=" || item.operator == "<" || item.operator == "<=") {
            expr = expr + item.lbracket + item.computeField + item.operator + item.value + item.rbracket + item.relation;
          } else {
            switch (item.operator) {
              case "equal": expr = expr + item.lbracket + item.computeField + "==\"" + item.value + "\"" + item.rbracket + item.relation; break;
              case "notequal": expr = expr + item.lbracket + item.computeField + "!=\"" + item.value + "\"" + item.rbracket + item.relation; break;
              case "==null": expr = expr + item.lbracket + item.computeField + "==null" + item.rbracket + item.relation; break;
              case "!=null": expr = expr + item.lbracket + item.computeField + "!=null" + item.rbracket + item.relation; break;
              case "Contains": expr = expr + item.lbracket + "DefaultFunction.Contains(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
              case "NotContains": expr = expr + item.lbracket + "DefaultFunction.NotContains(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
              case "StartsWith": expr = expr + item.lbracket + "DefaultFunction.StartsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
              case "NotStartsWith": expr = expr + item.lbracket + "DefaultFunction.NotStartsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
              case "EndsWith": expr = expr + item.lbracket + "DefaultFunction.EndsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
              case "NotEndsWith": expr = expr + item.lbracket + "DefaultFunction.NotEndsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
              case "OrgAffiliation": expr = expr + item.lbracket + "DefaultExtendFunction.OrgAffiliation(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket + item.relation; break;
            }
          }
        } else {
          if (item.operator == "==" || item.operator == "!=" || item.operator == ">" ||
            item.operator == ">=" || item.operator == "<" || item.operator == "<=") {
            expr = expr + item.lbracket + item.computeField + item.operator + item.value + item.rbracket;
          } else {
            switch (item.operator) {
              case "equal": expr = expr + item.lbracket + item.computeField + "==\"" + item.value + "\"" + item.rbracket; break;
              case "notequal": expr = expr + item.lbracket + item.computeField + "!=\"" + item.value + "\"" + item.rbracket; break;
              case "==null": expr = expr + item.lbracket + item.computeField + "==null" + item.rbracket; break;
              case "!=null": expr = expr + item.lbracket + item.computeField + "!=null" + item.rbracket; break;
              case "Contains": expr = expr + item.lbracket + "DefaultFunction.Contains(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
              case "NotContains": expr = expr + item.lbracket + "DefaultFunction.NotContains(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
              case "StartsWith": expr = expr + item.lbracket + "DefaultFunction.StartsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
              case "NotStartsWith": expr = expr + item.lbracket + "DefaultFunction.NotStartsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
              case "EndsWith": expr = expr + item.lbracket + "DefaultFunction.EndsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
              case "NotEndsWith": expr = expr + item.lbracket + "DefaultFunction.NotEndsWith(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
              case "OrgAffiliation": expr = expr + item.lbracket + "DefaultExtendFunction.OrgAffiliation(" + item.computeField + ",\"" + item.value + "\")" + item.rbracket; break;
            }
          }
        }
      })
    }
    return expr;
  }

}

